import { block } from "./block.js";
// default variables
export const blocksVars = {
    ids: undefined,
    // height: undefined,
    minHeight: undefined,
    maxHeight: undefined,
    pageSize: 10,
    after: undefined,
    sort: "DESC", // REMAPPED
};
export const arweaveBlocksQuery = {
    name: "blocks",
    query: block,
    vars: blocksVars,
    enumValues: ["sort"],
    remapVars: {
        pageSize: "first",
        // replace ASC/DESC to HEIGHT prefixed versions
        sort: (k, v) => [k, v === "ASC" ? "HEIGHT_ASC" : "HEIGHT_DESC"],
        minHeight: (_k, v, vars) => {
            vars.height = { ...vars.height, min: v };
            vars.minHeight = undefined;
        },
        maxHeight: (_k, v, vars) => {
            vars.height = { ...vars.height, max: v };
            vars.maxHeight = undefined;
        },
    },
    paging: {
        hasNextPage: "hasNextPage",
        cursor: "cursor",
    },
};
//# sourceMappingURL=blocks.js.map